import React from "react";
import { motion } from "framer-motion";
import { SITE, whatsappLink } from "@/data/site";
import { czk, getBundle } from "@/lib/price";

export function ReservationSuccess({ reservation, onReset }) {
  const loc = SITE.locations.find((l) => l.key === reservation.location)?.name || reservation.location;
  const addons = (reservation.addons || []).map((k) => SITE.addons.find((a) => a.key === k)).filter(Boolean);

  return (
    <section
      id="reservation"
      data-testid="reservation-section"
      className="relative bg-brand-bg py-24 lg:py-32 border-t border-brand-border"
    >
      <div className="max-w-3xl mx-auto px-6 lg:px-10 text-center">
        <motion.div
          initial={{ opacity: 0, scale: 0.95 }}
          animate={{ opacity: 1, scale: 1 }}
          transition={{ duration: 0.5 }}
          data-testid="reservation-success"
        >
          <div className="inline-flex items-center justify-center w-20 h-20 border border-brand-accent text-brand-accent text-3xl mb-8">
            ✓
          </div>
          <h2 className="font-display font-black text-4xl lg:text-5xl">
            Poptávku jsme <span className="italic font-light text-brand-accent">přijali.</span>
          </h2>
          <p className="mt-6 text-brand-muted leading-relaxed">
            Poptávku jsme přijali. Ozveme se vám na {reservation.phone} a potvrdíme termín.
            {reservation.member_id && " Zároveň jste členem CARSPA CLUB — přihlašovací odkaz do účtu najdete v e-mailu."}
          </p>

          <div className="mt-8 inline-block text-left bg-brand-surface border border-brand-border p-6 min-w-[280px]" data-testid="reservation-summary">
            <div className="flex justify-between gap-8 text-sm py-1">
              <span className="text-brand-muted">Pobočka</span>
              <span className="text-white font-semibold">{loc}</span>
            </div>
            <div className="flex justify-between gap-8 text-sm py-1">
              <span className="text-brand-muted">Termín</span>
              <span className="text-white font-semibold">domluvíme telefonicky</span>
            </div>
            <div className="flex justify-between gap-8 text-sm py-1">
              <span className="text-brand-muted">Program 4 v 1</span>
              <span className="text-white">{czk(reservation.base_price)}</span>
            </div>
            {(reservation.bundles || []).map((k) => {
              const b = getBundle(k);
              return b ? (
                <div key={k} className="flex justify-between gap-8 text-sm py-1" data-testid={`reservation-summary-bundle-${k}`}>
                  <span className="text-brand-muted">{b.label}</span>
                  <span className="text-brand-accent">+{czk(b.price)}</span>
                </div>
              ) : null;
            })}
            {addons.map((a) => (
              <div key={a.key} className="flex justify-between gap-8 text-sm py-1">
                <span className="text-brand-muted">{a.label}</span>
                <span className="text-brand-accent">+{czk(a.price)}</span>
              </div>
            ))}
            {reservation.surcharge_price > 0 && (
              <div className="flex justify-between gap-8 text-sm py-1" data-testid="reservation-summary-surcharge">
                <span className="text-brand-muted">SUV / velký vůz +{reservation.surcharge_pct} %</span>
                <span className="text-white">+{czk(reservation.surcharge_price)}</span>
              </div>
            )}
            <div className="border-t border-brand-border mt-3 pt-3 flex justify-between gap-8">
              <span className="text-white font-semibold">Celkem</span>
              <span className="font-display font-black text-brand-accent text-xl" data-testid="reservation-summary-total">
                {czk(reservation.total_price)}
              </span>
            </div>
          </div>

          <div className="mt-10 flex flex-wrap justify-center gap-4">
            <a
              href={whatsappLink(`Dobrý den, právě jsem odeslal rezervaci (${loc}). Rád bych domluvil termín.`)}
              target="_blank"
              rel="noreferrer"
              className="bg-brand-accent text-black font-semibold px-7 py-4 hover:bg-brand-accentHover transition-all"
            >
              Napsat na WhatsApp
            </a>
            <button
              onClick={onReset}
              data-testid="reservation-new-button"
              className="px-7 py-4 border border-brand-border hover:border-brand-accent hover:text-brand-accent transition-all"
            >
              Nová rezervace
            </button>
          </div>
        </motion.div>
      </div>
    </section>
  );
}
